"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var output_value_style_1 = require("../../../../theming/pricing-system/output-value.style");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var field_1 = require("../../layout/field/field");

var label_1 = require("../label/label");

var animationRangeMax = 100;
var animationDuration = 1000;

var OutputField = function (_super) {
  __extends(OutputField, _super);

  function OutputField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      animationStep: new react_native_1.Animated.Value(0)
    };
    return _this;
  }

  OutputField.prototype.render = function () {
    var outputValueTextStyle = this.props.isPlaceholder ? theme_pricing_system_1.pricingStyles.outputValuePlaceholderTextStyle : theme_pricing_system_1.pricingStyles.outputValueTextStyle;
    var importantTextStyle = {
      fontWeight: this.props.isImportant ? 'bold' : 'normal'
    };
    var startingColor = this.getStartingColor(outputValueTextStyle);
    var color = this.defineAnimationInterpolation([startingColor, output_value_style_1.outputValueAnimationDarkestColor, output_value_style_1.outputValueAnimationDarkestColor, startingColor]);
    var scale = this.defineAnimationInterpolation([1, output_value_style_1.outputValueAnimationScaleMax, output_value_style_1.outputValueAnimationScaleMax, 1]);
    var animationStyle = {
      color: color,
      transform: [{
        scale: scale
      }]
    };
    var numberOfLines = this.props.allowWrap ? undefined : 1;
    var labelViewStyle = this.props.isCentered ? {
      alignItems: 'center'
    } : {};
    var textStyle = this.props.isCentered ? {
      textAlign: 'center'
    } : {};
    return react_1.default.createElement(field_1.Field, {
      viewStyle: this.props.viewStyle
    }, react_1.default.createElement(label_1.Label, {
      label: this.props.label,
      viewStyle: labelViewStyle
    }, react_1.default.createElement(react_native_1.Animated.Text, {
      style: [outputValueTextStyle, textStyle, animationStyle, importantTextStyle],
      numberOfLines: numberOfLines
    }, this.props.value)));
  };

  OutputField.prototype.componentDidUpdate = function (props) {
    var _this = this;

    if (!props.isAnimated || props.value === this.props.value) {
      return;
    }

    react_native_1.Animated.timing(this.state.animationStep, {
      duration: animationDuration,
      toValue: animationRangeMax
    }).start(function () {
      _this.setState({
        animationStep: new react_native_1.Animated.Value(0)
      });
    });
  };

  OutputField.prototype.getStartingColor = function (valueTextStyle) {
    var initialStyles = react_native_1.StyleSheet.flatten(valueTextStyle);

    if (this.props.isPlaceholder) {
      return initialStyles.color;
    }

    return this.props.color ? this.props.color : initialStyles.color;
  };

  OutputField.prototype.defineAnimationInterpolation = function (outputRange) {
    return this.state.animationStep.interpolate({
      inputRange: [0, this.getPercentOfValue(animationRangeMax, 30), this.getPercentOfValue(animationRangeMax, 70), animationRangeMax],
      outputRange: outputRange
    });
  };

  OutputField.prototype.getPercentOfValue = function (value, percent) {
    return value * (percent * 0.01);
  };

  return OutputField;
}(react_1.default.Component);

exports.OutputField = OutputField;